import ApiBase from 'Services/Api/ApiBase';

class Users extends ApiBase {
    route = '/admin/human-resources/users';
};

export default new Users();